export function formatStorePrice(price, fallback = "Unavailable") {
  if (!price || price.price === null || price.price === undefined) {
    return fallback;
  }
  const amount = Number(price.price) / 100;
  if (!Number.isFinite(amount)) {
    return fallback;
  }
  const formattedAmount = amount.toFixed(2);
  const currency = String(price.currency || "").toLowerCase();
  if (currency === "gbp") {
    return `£${formattedAmount}`;
  }
  if (currency === "aud") {
    return `AUD$${formattedAmount}`;
  }
  return fallback;
}

export function formatBuyNowLabel(price) {
  const formattedPrice = formatStorePrice(price, null);
  return formattedPrice ? `Buy now - ${formattedPrice}` : "Buy now";
}
